import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { LanguageSwitcher } from '../atoms/LanguageSwitcher.js';

interface MinimalLayoutProps {
  children: ReactNode;
}

export function MinimalLayout({ children }: MinimalLayoutProps) {
  const { t } = useTranslation();

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-neutral-50 px-4">
      <div className="absolute right-4 top-4">
        <LanguageSwitcher />
      </div>
      <div className="w-full max-w-md">{children}</div>
      <footer className="mt-8 text-center text-xs text-neutral-400">
        <a href="/privacy" className="hover:text-neutral-600">
          {t('footer.privacy')}
        </a>
        <span className="mx-2">|</span>
        <a href="/terms" className="hover:text-neutral-600">
          {t('footer.terms')}
        </a>
      </footer>
    </div>
  );
}
